import styled from "styled-components";
import React from "react";
import {useTranslation} from "react-i18next";
import {LANGUAGE_PATH, useMediaQuery} from "modules";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {PrimaryButton, SecondaryButton} from "apps/DRAW_PREDICTOR/components/Buttons";
import {useDispatch} from "react-redux";
import {editPreDraw} from "apps/DRAW_PREDICTOR/modules/actions";
import {media} from "assets/css/media";
import {Exist} from "components";
import {NavLink} from "react-router-dom";

const Wrapper = styled.div`
	position: sticky;
	bottom: 0;
	width: 100%;
	height: 105px;
	background: #ffffff;

	--defaultPaddingBottom: 12px;
	padding-bottom: var(--defaultPaddingBottom);
	/* iOS Safari 11.2, Safari 11 */
	padding-bottom: calc(
		var(--defaultPaddingBottom) + constant(safe-area-inset-bottom, var(--defaultPaddingBottom))
	);
	/* iOS Safari 11.4+, Safari 11.1+, Chrome 69+, Opera 56+ */
	padding-bottom: calc(
		var(--defaultPaddingBottom) + env(safe-area-inset-bottom, var(--defaultPaddingBottom))
	);
`;

const InnerWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	height: 100%;
	max-width: 1440px;
	margin: 0 auto;
	padding: 0 20px;
	div p svg {
		margin-inline-end: 5px;
		width: 24px;
		margin-bottom: 5px;
	}
`;

const Title = styled.p`
	font-family: "Qatar2022";
	font-size: 18px;
	line-height: 140%;
	display: flex;
	align-items: center;
	font-weight: 500;
`;

const Desc = styled.p`
	font-family: "Graphik";
	font-size: 16px;
	font-weight: 500;
	line-height: 160%;
	color: #03122b;
`;

const Buttons = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;
	@media (max-width: ${media.mobile}) {
		width: 100%;
		justify-content: center;
	}
`;
const InfoContent = styled.div`
	width: 75%;
`;

export const PreDrawResultsBar: React.FC = () => {
	const {t} = useTranslation(LANGUAGE_PATH);
	const dispatch = useDispatch();
	const isMobile = useMediaQuery(`(max-width: ${media.mobile})`);

	const edit = () => {
		dispatch(editPreDraw());
	};

	return (
		<Wrapper>
			<InnerWrapper>
				<Exist when={!isMobile}>
					<InfoContent>
						<Title>
							<InfoOutlinedIcon /> {t("review.page.bar_header")}
						</Title>
						<Desc>{t("review.page.bar_info")}</Desc>
					</InfoContent>
				</Exist>

				<Buttons>
					<PrimaryButton as={NavLink} to="/predictions">
						{t("review.page.bar_next")}
					</PrimaryButton>
					<SecondaryButton onClick={edit}>{t("review.page.bar_edit")}</SecondaryButton>
				</Buttons>
			</InnerWrapper>
		</Wrapper>
	);
};
